// extracted by mini-css-extract-plugin
export default {"clicked":"ClickableDiv-module__clicked--iRYiA"};